import React from 'react';
import styles from '../AlertCard.scss';
import Toggle from './Common/Toggle';
import CppPopup from '../../../common/CppPopup';
import DialogBox from '../../../../Common/CommonComponents/sceDialogBox';
import SetNotification from './Common/Presentational/NotificationPreferencesDialogBoxes/setNotificationCpp';
import { BrowserRouter as Router } from 'react-router-dom';
import  HoverCPEmail from "./Common/hoverCPEmail";
import  HoverCPPhone from "./Common/hoverCPPhone";
import { withRouter, browserHistory } from 'react-router';
import RemovePreference from './Common/Presentational/NotificationPreferencesDialogBoxes/removePreference';
import EditPreference from './Common/Presentational/NotificationPreferencesDialogBoxes/editPreference.js';
import CustomerAccountComponent from './customerAccountComponent';
import { getLocalizedStrings } from './notificationLocalizedStrings';
import GlobalErrorBlock from '../../../../Common/CommonComponents/GlobalErrorBlock/globalErrorBlock';
import NotificationHelper from './Common/Presentational/NotificationPreferencesDialogBoxes/dropDown/notificationHelper';
import LoaderPopup from './../../../../Common/CommonComponents/AppSpinner/appSpinner';
import ReactHtmlParser from 'react-html-parser';

class CriticalPeakPricing extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      prefData: '',emailOn: null,phoneOn: null,textOn: null,checked: null,isOpen: false,cppEnroll: false,cppDeEnroll: false,displayDialog: false,closePopUp: false,bpObj: '',viewEditOpen: false,enrollStatus: '',addressGuid: '',dropDownData: '',hoverData:'',
      bpNumber: {}, bpPreferenceSet: {}, isTimeoutError: false, customerAccountData: {}, deleteDetails: {}, addressBookData: {}, selectedSactDetails: {}, serviceAccountData: {}, serviceCallData: { fetchPrefDetails: { isfetchPreferenceCallSucceededJustNow: false, deviceType: '', value: '', previousSelectedValue: '', maskedPhoneNumber: '' } }, analyticsData: {}, showLoadingIndicator: false, setNotificationData: {}, isGlobalError: false, sactEnrollmentDetails: {}, customerAccountViewState: { showAddressBook: false, showResidentialAssign: false, showEditContact: false, showResidentialSetNotification: false, showCreateContact: false, showDeleteContact: false, showAssignContact: false, showRemoveContact: false, assignContactFlow: false, showRemoveContactSelection: false, showModifyContact: false, },
      contactAssignmentViewState: { showModifyContact: false, showRemoveContact: false, showResidentialSetNotification: false, showAssignContact: false, setNotificationFlow: false, assignContactFlow: false, showAddressBook: false, showEditContact: false, showCreateContact: false,hoverType:'', showDeleteContact: false, globalErrorCode: '' }, isShowMoreCAClicked: 0,
      mainBPNumber: app.appService.getUserInfo() && app.appService.getUserInfo().profileData && app.appService.getUserInfo().profileData.accountData && app.appService.getUserInfo().profileData.accountData.mainBusinessPartner ? app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber || '' : '', shouldFetchPrefDetailsWhenSameBP: 'yes',
      preferenceData: this.props.bpPreferenceSet,isCppErr:false,isCppDeEnrollError:false,hoverModal:false,hoverPhoneModal:false,deenrolled:false,toggleDisabled:true,
    };
    this.selectedServiceAccountResidential = '', this.multiSelect = false;
    this.selectedCustomerAccountData = {}, this.selectedContactsToRemove = [], this.selectedServiceAccount = '';
    this.viewEditPopUpHandler = this.viewEditPopUpHandler.bind(this);
    this.imageMail_On = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg',this.imageMail_Off = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
    this.imagePhone_On = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg',this.imagePhone_Off = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOff.svg';
    this.imageText_On = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg', this.imageText_Off = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOff.svg';
    this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
    let imageMailOn,imageMailOff,imageTextOn,imageTextOff,imagePhoneOn,imagePhoneOff;
    this.button = <button id="criticalPeakPricingView" className={styles.ViewEditButton} onClick={this.viewEditPopUpHandler} >View / Edit</button>;
    // ----------------------------
    this.strings = getLocalizedStrings('CPPSpecific');
    this.selectedServiceAccountData, this.selectedCustomerAccount = {};
    this.componentType = this.strings.componentType;
    this.selectedServiceAccountId;
    this.initialDataFetch = false;
    this.serviceCallInProgress = true;
    this.initialPositionValue = window.getComputedStyle(document.body).position;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState(
        {
          prefData: nextProps.preferenceData,emailOn: nextProps.preferenceData.email_id.length > 0 ? true : false,
          phoneOn: nextProps.preferenceData.phoneNo.length > 0 ? true : false,textOn: nextProps.preferenceData.textNo.length > 0 ? true : false,
        },() => {this.handle();}
      );
    }
  }

  //Displays the loading indicator .
  showLoader() {this.setState({ showLoadingIndicator: true });}

  //Is invoked on confirming the contacts to be removed from service account(s) and calls the service for removing contacts from service account(s) .
  onRemoveAssignedContactConfirmHandler(requestObj, viewState, shouldRemoveContact) {
    this.showLoader();
    app.centralizedService.enrollResidentialContact(this.state.bpNumber, requestObj, this.state.bpPreferenceSet, shouldRemoveContact, this.state.customerAccountData.selectedAccount).then(response => {
      if (!response.errorCode) {
        // error
      } else {
        this.handleServiceError();
      }
    }, error => { this.handleServiceError(error); });
  }
  viewHoverPopUp =()=>{ 
    if(this.props.preferenceData.email_id.length >0){
    this.setState({ hoverModal: true,categoryType:'3' });
    } 
  }
  viewHoverPhone =(category)=>{ 
    if(category===1 && this.props.preferenceData.phoneNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.phoneNo ,hoverPhoneModal: true, hoverModal: false,hoverType:'text',categoryType:'1'});
    } else if(category===2 && this.props.preferenceData.textNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.textNo ,hoverPhoneModal: true,hoverModal: false,hoverType:'voice' ,categoryType:'2' });
    }
  }
  componentDidUpdate() {
    // Bind the event listener
    if(this.state.categoryType==='3') {
      document.addEventListener("mousedown", this.handleEmailClose);
    }else{
      document.addEventListener("mousedown", this.handlePhoneClose);
    }
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount(){
    if(this.state.categoryType==='3') {
      document.removeEventListener("mousedown", this.handleEmailClose);
    }else{
      document.removeEventListener("mousedown", this.handlePhoneClose);
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
    app.appUtil.unsetFontAwesomeNesting();
  }
  handleEmailClose=()=>{ this.state.hoverModal ? this.setState({ hoverModal: false }) : null;}
  handlePhoneClose=()=>{ this.state.hoverPhoneModal ? this.setState({ hoverPhoneModal: false }) : null;}
  //Is invoked on successfull removal of contact from service account.Manages the post service call view state
  onRemoveContactSuccessHandler(response, contactData, viewState, shouldRemoveContact) {
    let updateStateData = { ...this.state };
    updateStateData.serviceCallData = contactData, updateStateData.customerAccountData.caList[this.selectedCustomerAccount.customerAccountIndex].selectAllServiceAccount = false;
    (contactData.multiSelect) ? updateStateData.customerAccountViewState.showRemoveContact = false : updateStateData.customerAccountViewState = viewState;
    (contactData.multiSelect) ? updateStateData.serviceCallData.serviceCallSucceeded = true : null;
    updateStateData.showLoadingIndicator = false;
    (response.updatedServiceAccountDetailsData) ? updateStateData.selectedSactDetails = response.updatedServiceAccountDetailsData : null;
    this.setState(updateStateData);
  }

  updateViewState = (viewState, fetchPrefDetails) => {
    var updatedState = { ...this.state };
    viewState ? updatedState.customerAccountViewState = viewState : null;
    fetchPrefDetails ? updatedState.serviceCallData.fetchPrefDetails = fetchPrefDetails : null;
    this.setState(updatedState);
  }
  refreshPage () {
       this.props.refreshPage(
         this.props.accountData.contractAccountNumber, this.props.accountData.contractResults[0].contractNumber, this.props.accountData.contractResults[0].premiseNumber,false, this.props.accountData.bpNumber, this.props.accountData.bpCategory);
  }
  handleServiceError(error) {
    if (error.errorCode === app.appUtil.getAppConstants().TIMEOUT_EXCEPTION) {
      this.setState({ ...this.state,showLoadingIndicator:false, isTimeoutError: true });
    } else {
      this.setState({ isGlobalError: true,showLoadingIndicator:false, globalErrorCode: 'globalErrorCode' });
    }
  }
  saveResidentialContacts(requestObj, viewState, shouldRemoveContact) {
    this.showLoader();
  app.centralizedService.enrollResidentialContact(this.props.accountData.bpNumber, requestObj, this.state.bpPreferenceSet, shouldRemoveContact,this.props.mainBpNumber,this.props.accountData.bpCategory,this.props.accountData.contractAccountNumber).then(response => {
   
      if (response.errorCode || (response.message && response.message === '')||  response.status ==="F"){
        this.handleServiceError(response);
        this.setState({isCppDeEnrollError:true,isCppErr:true},()=>{});}
      else {
        let updateServiceCallData = { ...this.state.serviceCallData }, updatedCustomerData = { ...this.state.customerAccountData }, updatedCustomerAccountViewState = { ...this.state.customerAccountViewState }, updatedBpPreferenceSet = {...this.state.bpPreferenceSet};
        updateServiceCallData.viewState = viewState;
        (!shouldRemoveContact) ? updateServiceCallData.serviceCallType = this.strings.saveContactKey : updateServiceCallData.serviceCallType = this.strings.residentialRemove;
        var serviceAccountData = { ...this.state.serviceAccountData }, customerAccountData = { ...this.state.customerAccountData };
        serviceAccountData.saAccList = NotificationHelper.getUpdatedSaAccList(serviceAccountData.saAccList, shouldRemoveContact);
        // customerAccountData.caList = NotificationHelper.getUpdatedCaList(customerAccountData.caList);
        updatedCustomerAccountViewState = viewState;
        updateServiceCallData.serviceCallSucceeded = true;
       
        if (!shouldRemoveContact){
          this.setState({ showLoadingIndicator: false, customerAccountViewState: updatedCustomerAccountViewState, serviceCallData: updateServiceCallData, serviceAccountData: serviceAccountData, customerAccountData: customerAccountData, checked: true, cppEnroll: false, viewEditOpen: false }, () => { });
          // adding 600ms delay for refresh when its single account(Fix for ANC-877)
          let timeout = this.props.isMultiAcc === 1 ? 0 : 600;
          setTimeout(() => {
            this.refreshPage();
          }, timeout);
        }else {
          // ANC-393 : When Turn off CPP is succussful manually empty previous preference data instead of making service call to get updated data.
          this.setState({ showLoadingIndicator: false, customerAccountViewState: updatedCustomerAccountViewState, serviceCallData: updateServiceCallData, serviceAccountData: serviceAccountData, customerAccountData: customerAccountData, checked: false, cppDeEnroll: false , deenrolled:true}, () => {
            this.props.removePreference('cpp', 'formattedDataForCpp');
          });
        }
         // ANC-798
         this.setState({isCppDeEnrollError:false,isCppErr:false},()=>{});
       
      }
    }, error => { 
      this.handleServiceError(error);
      this.setState({isCppDeEnrollError:true,isCppErr:true},()=>{});
    });
  }
    
  onModifyCustomerPreference(requestObj, viewState, addNewDevieDetailFlag, deleteDeviceDetailFlag) {
        let updatedState = { ...this.state };
        let dropDownData = updatedState.dropDownData;
        if(requestObj.deviceType==="email"){
            let newObj={
              "email": requestObj.modifiedValue,"standardIndicatorEmail": "","objectKey": "","record_guid": "NEW",
              "channel": "INT","sequenceNumber": "","status": "","removeFromDate": null,"addModifyFromDate": null,"addModifyToDate": null
          };
          dropDownData.emailSet.push(newObj);
        }
        else if(requestObj.deviceType==="voice"){
          let newObj={
            "telephoneNumber": requestObj.maskedValue,"encryptedPhoneNumber":requestObj.modifiedValue,"standardIndicatorVoice": "","objectKey": "",
            "record_guid": "NEW","channel": "TEL","sequenceNumber": "","indicatorSmsEnabled": "X","indicatorTelephone": "",
            "status": "","removeFromDate": null,"addModifyFromDate": null,"addModifyToDate": null
          };
          dropDownData.phoneSet.push(newObj);
          let mobileObject={...newObj, "channel": "PAG"};
          dropDownData.mobileSet.push(mobileObject);
        }else{
          let newObj={
            "telephoneNumber": requestObj.maskedValue,"encryptedPhoneNumber":requestObj.modifiedValue,"standardIndicatorVoice": "","objectKey": "",
            "record_guid": "NEW","channel": "PAG","sequenceNumber": "","indicatorSmsEnabled": "X","indicatorTelephone": "",
            "status": "", "removeFromDate": null,"addModifyFromDate": null,"addModifyToDate": null
          };
          dropDownData.mobileSet.push(newObj);
          let mobileObject={...newObj, "channel": "TEL"};
          dropDownData.phoneSet.push(mobileObject);
        }
        this.setState(updatedState);
        this.props.updateDropDownData(dropDownData);
  }
  
  handle() {
    let accountData = this.props.isMultiAcc === 1 ? this.props.expandedContract : this.props.accountData.contractResults[0];
    let serviceAccountData = {
      'saAccList': [
        {
          'contractNumber': accountData.contractNumber,'email': '','houseNumber': accountData.houseNumber,'unitNumber': '',
          'address': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
          'sreetAddress': accountData.streetAddress, 'city': accountData.city,'state': accountData.state,
          'zipCode': accountData.zipcode,'premiseNumber': accountData.premiseNumber,'serviceAddress': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
          'serviceAccountIndex': 0,'isSelected': true,'contractBpNumber':this.props.accountData.bpNumber
        }
      ],
      'serviceAccountCount': 1
    };
    this.serviceCallInProgress = false;
    this.setState({ serviceAccountData: serviceAccountData });
    if (this.props.isMultiAcc === 1) {
      this.setState({ bpPreferenceSet: this.props.formattedDataForCpp, dropDownData:this.props.dropDownData, addressGuid:this.props.dropDownData.addressGuid });
    } else { this.setState({ bpPreferenceSet: this.props.cpcData.cppPreferenceSet, dropDownData: this.props.dropDownData,addressGuid: this.props.cpcData.customerDetails[0].addressGuid }); }
    this.setState({ bpNumber: this.props.cpcData.bpNumber });
    this.setState({ checked: this.state.emailOn || this.state.phoneOn || this.state.textOn ? true : false , toggleDisabled:false});
    this.imageMailOn = this.state.emailOn ? <img src={this.imageMail_On} alt="Mail Image On" /> : <img src={this.imageMail_Off} alt="Mail Image Off" />;
    this.imagePhoneOn = this.state.phoneOn ? <img src={this.imagePhone_On} alt="Phone Image On" /> : <img src={this.imagePhone_Off} alt="Phone Image Off" />;
    this.imageTextOn = this.state.textOn ? <img src={this.imageText_On} alt="Text Image On" /> : <img src={this.imageText_Off} alt="Text Image Off" />;
  }


  turnOnCppHandler(enrollStatus) {
    const updatedState = { ...this.state };
    if (enrollStatus) updatedState.cppEnroll = true;
    else updatedState.cppDeEnroll = true;
    this.setState(updatedState);
    window.scrollTo(0,0);
  }

  viewEditPopUpHandler() { 
    window.aUtils.sendAAEvent("button","criticalPeakPricingView/Edit");
    this.setState({ viewEditOpen: true,isCppErr:false }); 
    window.scrollTo(0,0);
  }
  cancelButtonHandler() { this.setState({ cppEnroll: false,isCppErr:false }); }
  closeDeEnrollPopUpHandler() { this.setState({ cppDeEnroll: false, isCppDeEnrollError: false });}
  closeEnrollPopUpHandler() { this.setState({ cppEnroll: false ,isCppErr:false}); }
  closeViewEditPopUpHandler(){this.setState({ viewEditOpen:false,isCppErr:false });}
  overlayFocusController() {
    if(this.state.cppEnroll || this.state.viewEditOpen || this.state.cppDeEnroll) {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.position = this.initialPositionValue;
      document.body.style.removeProperty("width");
    }
  }
  onHoverOverEvent =(e)=>{
    if(e.type === "mouseenter"){
      this.setState({infoPopUp:true});
    }
  }
  onHoverOutEvent = (e) =>{ this.setState({infoPopUp:false});}
  toolTipKeyPress= (e) =>{
    if(e.key === "Enter"){
    this.setState({infoPopUp:!this.state.infoPopUp});}}
    render() {
    this.overlayFocusController();
    return (
      <div>
        {this.state.showLoadingIndicator ? <LoaderPopup /> : null}
        <div onMouseLeave={this.onHoverOutEvent}>
          {this.state.infoPopUp && <div><CppPopup infoPopupTxt={ReactHtmlParser(this.props.staticContent.infoPopupTxt)} /></div>}
          {this.state.hoverModal && <HoverCPEmail  preferenceData={this.props.preferenceData.email_id}  handleEmailClose={this.handleEmailClose.bind(this)} />}
          {this.state.hoverPhoneModal && <HoverCPPhone  preferenceDataPhone={this.state.hoverData} hoverText={this.state.hoverType} handlePhoneClose={this.handlePhoneClose.bind(this)} />}  
          <div className={styles.AlertCards} id="criticalPeakPricingInfoPopUp">
            <div className={styles.MainContainer}>
              <div className={styles.LeftContainer} >
                <div className={styles.AlertCardData}>
                  <p className={styles.AlertCardTitle} onMouseEnter={this.onHoverOverEvent} onClick={this.onHoverOverEvent} > {this.props.AlertName1}
                  <span className={styles.InfoIcon}>{this.props.AlertName2}<img tabIndex={0} onKeyPress={this.toolTipKeyPress} className={styles.iconAlign} src={this.imageInfo} alt="Info Icon" /></span>
                   </p>
                  
                  <p className={styles.AlertCardSubtitle} onMouseEnter={this.onHoverOutEvent}> {ReactHtmlParser(this.props.staticContent.subTxt)}</p> 
                   <div className={styles.ButtonSection} >
                    {(this.state.checked) ?
                      <span><span  onClick={this.viewHoverPopUp.bind(this)}> {this.imageMailOn}</span>
                      <span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,2)} >{this.imageTextOn}</span>
                      <span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,1)}>{this.imagePhoneOn}</span>
                    {this.button}</span>: null}
                  </div></div></div>
              <div className={styles.DividerLine} /><div className={styles.RightContainer}><div className={styles.SwitchAlign}>
                  <Toggle isToggleOn={this.state.checked} handleToggle={this.turnOnCppHandler.bind(this)} isDisabled={this.state.toggleDisabled} />
              </div></div></div></div></div>
        <CustomerAccountComponent
          bpNumber={this.props.mainBpNumber} bpPreferenceSet={this.state.bpPreferenceSet} deleteDetails={this.state.deleteDetails} selectedCustomerAccount={this.selectedCustomerAccount} serviceCallInProgress={this.serviceCallInProgress} isCPPEligible={(this.state.serviceAccountData && (this.state.serviceAccountData.serviceAccountCount > 0))} updateViewState={this.updateViewState} componentType={this.componentType} setNotificationData={this.state.setNotificationData} strings={this.strings} serviceCallData={this.state.serviceCallData} analyticsData={this.state.analyticsData}
          isShowMoreCAClicked={this.state.isShowMoreCAClicked} showLoadingIndicator={this.state.showLoadingIndicator} customerData={this.state.customerAccountData} viewState={this.state.customerAccountViewState} serviceAccountData={this.state.serviceAccountData}
          onRemoveConfirmation={(contactData, viewState, shouldRemoveContact) => this.onRemoveAssignedContactConfirmHandler(contactData, viewState, shouldRemoveContact)}
          addressBookData={this.state.addressBookData} addedContactSaveHandler={(contactData) => this.addedContactSaveHandler(contactData)} sactEnrollmentDetails={this.state.sactEnrollmentDetails} onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)}saveResidentialContacts={this.saveResidentialContacts.bind(this)} cppDeEnrollError={this.state.isCppDeEnrollError} onServiceCallSuccessViewStateSave={(customerData, showLoadSpinner, type) => this.fetchDeviceDetails(customerData, showLoadSpinner, type)} closePopUp={this.closeEnrollPopUpHandler.bind(this)} dropDownData={this.state.dropDownData} contractAccountNumber={this.props.accountData.contractAccountNumber} contractNumbercount={this.props.accountData.contractNumbercount}
          isViewEditOpen={this.state.viewEditOpen} isCppEnroll={this.state.cppEnroll} isCppDeEnroll={this.state.cppDeEnroll} closeDeEnrollPopUp={this.closeDeEnrollPopUpHandler.bind(this)}closeViewEditPopUp={this.closeViewEditPopUpHandler.bind(this)} multiSelect={this.multiSelect} isCppErr={this.state.isCppErr}
        /> 
      </div>
    );
  }
}
export default CriticalPeakPricing;
